<template>
    <div class="special-heading">
        <h3>Early Deposit</h3>
        <p class="mt-2 normal-case">Collect the earnest money deposit before the file has been created.</p>
    </div>

    <form
        id="addEarlyDepositForm"
        :action="formSubmitUrl"
        enctype="multipart/form-data"
        method="post"
        @submit.prevent="submitEarlyDepositForm"
    >
        <slot name="csrf" />

        <!-- TODO: Do we need these hidden fields for Early Deposits? -->
        <input
            id="amount_down"
            name="amount_down"
            type="hidden"
        />
        <input
            id="earnest_money"
            name="earnest_money"
            type="hidden"
        />
        <input
            id="sales_price"
            name="sales_price"
            type="hidden"
        />
        <input
            id="vendor"
            name="vendor"
            type="hidden"
            value=""
        />
        <input
            id="vendor_order_id"
            name="vendor_order_id"
            type="hidden"
            value=""
        />
        <input
            id="vendor_transaction_id"
            name="vendor_transaction_id"
            type="hidden"
            value=""
        />

        <div class="form-group -mx-2 flex flex-wrap">
            <label class="form-label w-3/12 px-2">
                <span class="hide-sm">Property Address</span>
                <span class="hide-lg">Address</span>
            </label>
            <div
                id="locationField"
                class="w-9/12 px-2"
            >
                <input
                    id="address"
                    class="form-control"
                    data-id="address"
                    name="address"
                    placeholder="Property address"
                    required
                    type="text"
                />
                <span
                    id="address_error"
                    class="form-control-error-description"
                    data-id="address.error"
                ></span>
            </div>
        </div>

        <SelectCompanyBranch :companies />

        <SelectWireDocHtml />

        <div
            id="input-balance-due-row"
            class="form-group -mx-2 flex flex-wrap"
        >
            <label class="form-label w-3/12 px-2">
                <span class="hide-sm">Deposit Amount</span>
                <span class="hide-lg">Deposit Amt.</span>
            </label>
            <div class="w-9/12 px-2">
                <input
                    id="balance_due"
                    ref="balanceDue"
                    autocomplete="off"
                    class="form-control"
                    data-id="balance_due"
                    name="balance_due"
                    placeholder="Deposit amount"
                    type="text"
                />
                <span
                    id="balance_due_error"
                    class="form-control-error-description"
                    data-id="balance_due.error"
                ></span>
            </div>
        </div>

        <div class="-mx-2 flex flex-wrap">
            <div class="w-full px-2">
                <label>Early Deposit</label>
                <i
                    aria-hidden="true"
                    class="fas"
                    title="Select wire instructions you need to securely share, and the recipients of the wire instructions."
                />
            </div>
        </div>

        <div
            id="sendWireSection"
            class="product-section"
        >
            <div class="form-group -mx-2 flex flex-wrap">
                <label
                    id="clients-container-label"
                    class="form-label w-3/12 px-2"
                >
                    <span class="hide-sm">Client Information</span>
                    <span class="hide-lg">Client Info.</span>
                </label>
                <div class="flex-center-vertical w-9/12 flex-col px-2">
                    <div class="clients-container">
                        <!-- {{-- filled by JS. See "client-contact-template" --}} -->
                    </div>
                    <div>
                        <small
                            id="addClientButton"
                            class="add_client_btn"
                        >
                            <span class="disable-text-select">
                                <i
                                    aria-hidden="true"
                                    class="fas fa-plus text-ds-green-500"
                                />
                                Add another client
                            </span>
                        </small>
                    </div>
                </div>
            </div>
        </div>

        <div
            id="fileNotificationSection"
            class="product-section"
        >
            <div class="form-group -mx-2 flex flex-wrap">
                <div class="w-6/12 px-2">
                    <label>Notification Recipients</label>
                    <i
                        aria-hidden="true"
                        class="fas fa-info-circle pl-2 text-content-primary"
                        title="Select team members who will get notified when clients complete tasks.
                    By default this will be the person who is opening the file."
                    />
                </div>
            </div>
            <div class="form-group -mx-2 flex flex-wrap">
                <div class="w-4/12 px-2">
                    <label class="form-label">Search Users</label>
                </div>
                <div class="w-8/12 px-2">
                    <input
                        id="add-file-search-users"
                        class="border-ds-primary-300"
                        type="text"
                    />
                </div>
            </div>
            <div class="form-group -mx-2 flex flex-wrap">
                <div class="w-4/12 px-2">
                    <label class="form-label">Selected Recipients</label>
                </div>
                <div class="w-8/12 px-2">
                    <div
                        id="add-file-selected-user-list"
                        class="min-h-[220px] rounded border border-ds-primary-300 p-3"
                    >
                        <!-- list of selected recipients -->
                    </div>
                </div>
            </div>
        </div>

        <br />

        <div class="form-group -mx-2 flex flex-wrap text-center">
            <div class="w-full px-2">
                <div
                    id="notify-label"
                    class="custom-control custom-checkbox"
                >
                    <input
                        id="notify-add-file"
                        checked
                        class="custom-control-input"
                        name="notify"
                        type="checkbox"
                        value="notify"
                    />
                    <label
                        class="custom-control-label"
                        for="notify-add-file"
                        >Send notification to client(s)</label
                    >
                </div>
            </div>
        </div>

        <div class="m-b-20 w-full px-2 text-center">
            <div
                id="errorBlockForHiddenOrMissingElements"
                class="form-control-error-description"
            >
                <!-- This error block is for all server error responses that are not inlined with the input element
            (e.g. if input element is hidden -->
            </div>
        </div>

        <div class="form-group text-center">
            <div class="w-full px-2">
                <LoadingSpinner
                    v-if="isFetchingEarlyDeposit"
                    class="m-auto"
                    size-classes="w-12 h-12"
                    :space="false"
                />
                <button
                    v-else
                    class="add-modal btn btn-primary btn-circle"
                    data-was-id="openAddModal"
                >
                    Send request
                </button>
            </div>
        </div>

        <slot name="add-client" />

        <!-- TODO: add confirm modal -->
    </form>
</template>

<script setup lang="ts">
import type { CreateEarlyDepositRequest } from '@/api/interfaces/early-deposit.types';
import { notifyError } from '@/bugsnag';
import { clearMainFormClients } from '@/company-portal/add-file';
import { HANDLED_ERROR, type ServerErrorResponse } from '@/company-portal/add-file/add-file-form-errors.types';
import { handleServerErrorResponse } from '@/company-portal/add-file/handle-form-errors';
import { verifyAllClientsHaveRoles, zipClientsFromFormArrays } from '@/company-portal/add-view-file';
import LoadingSpinner from '@/components/Icons/LoadingSpinner.vue';
import {
    makeErrorResponseCompatibleWithCreateFileValidation,
    useCreateEarlyDeposit,
    useEarlyDepositsPaged,
} from '@/services/early-deposit.service';
import { convertDollarsToCents } from '@/shared/utils/format-number';
import AutoNumeric from 'autonumeric';
import $ from 'jquery';
import { onMounted, ref } from 'vue';
import SelectCompanyBranch from './SelectCompanyBranch.vue';
import SelectWireDocHtml from './SelectWireDocHtml.vue';

defineProps<{
    companies: { id: string; name: string }[];
    formSubmitUrl: string;
}>();

const balanceDue = ref<HTMLElement>();
const { createEarlyDeposit, isFetchingEarlyDeposit } = useCreateEarlyDeposit();
const { refetchCurrentPage } = useEarlyDepositsPaged();

onMounted(() => {
    new AutoNumeric(balanceDue.value!, {
        currencySymbol: '$',
        minimumValue: '0',
        modifyValueOnWheel: false,
    });
});

const formDataToPayload = (formData: FormData): CreateEarlyDepositRequest => {
    const address = `${formData.get('address')}`;
    const branch_id = parseInt(`${formData.get('branch_id')}`, 10);
    const deposit_amount = convertDollarsToCents(`${formData.get('balance_due')}`.replaceAll(/[,$]/g, ''));
    const wire_doc_id = parseInt(`${formData.get('wireDoc_id')}`, 10);
    const notifying_users = formData.getAll('fileNotificationUserIds[]').map(entry => parseInt(`${entry}`, 10));

    const clients = zipClientsFromFormArrays(formData);
    return {
        address,
        branch_id,
        clients,
        deposit_amount,
        notifying_users,
        wire_doc_id,
    };
};

const submitEarlyDepositForm = async (evt: Event) => {
    if (!(evt.target instanceof HTMLFormElement)) {
        return notifyError(
            'submitEarlyDepositForm not triggered on an HTMLFormElement',
            'EarlyDepositForm:submitEarlyDepositForm',
            { event: evt },
        );
    }

    const formEl = evt.target;
    const formData = new FormData(formEl);

    // LIZA: this was copied from the bottom of getFormData.blade.php, and it would be nice if both places could just call some utility instead of straight up duplicating code,
    //       but getFormData.blade.php is somehow now a script module, and so the lift may be too large
    $(formEl)
        .find<HTMLInputElement>('input:enabled.client-phone')
        .each(function (index, element) {
            formData.set(element.name, $(element).intlTelInput('getNumber', intlTelInputUtils.numberFormat.INTERNATIONAL));
        });

    const payload = formDataToPayload(formData);

    try {
        verifyAllClientsHaveRoles(`#${formEl.id}`);
    } catch (error) {
        toastr.error('Please select a role for all clients');
        return;
    }

    const { error, response } = await createEarlyDeposit(payload);

    if (error.value) {
        const responseObj = response.value;

        if (responseObj === null) {
            toastr.error('An unknown error occurred, please try again later', 'Error', { timeOut: 5000 });
            notifyError(error.value, 'EarlyDepositForm:submitEarlyDepositForm', { payload });
            return;
        }

        const jqxhr: Pick<JQueryXHR<ServerErrorResponse>, 'status' | 'responseJSON'> = {
            responseJSON: await makeErrorResponseCompatibleWithCreateFileValidation(responseObj),
            status: responseObj.status,
        };

        handleServerErrorResponse(jqxhr, HANDLED_ERROR, `#${formEl.id}`);
        return;
    }

    toastr.success('Early Deposit created', 'Success!', { timeOut: 5000 });
    // refresh table in case the new EMD would be visible
    refetchCurrentPage();
    formEl.reset();

    // FIXME: this resets the Client widgets (phone, email, role, etc.), but they should be a Vue component instead of this jQuery managed DOM
    clearMainFormClients('#addEarlyDepositForm');
};
</script>

<style scoped>
.product-section {
    @apply border-t border-ds-primary-200 py-4;
}
</style>
